import { ToastProvider, TooltipProvider } from '@pms-digital/design-system';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from './lib/query-client';
import { router } from './lib/router';
import { installScrollbarVisibility } from './lib/scrollbar-visibility';
import { registerSessionExpiryHandler } from './lib/session-expiry';
import './styles.css';

// ── Sentry (optional) ────────────────────────────────────────────────────────
// Uncomment to enable error reporting. Requires VITE_SENTRY_DSN at build time.
//
// import * as Sentry from '@sentry/react';
// if (import.meta.env.VITE_SENTRY_DSN) {
//   Sentry.init({
//     dsn: import.meta.env.VITE_SENTRY_DSN,
//     environment: import.meta.env.MODE,
//     tracesSampleRate: 0.1,
//   });
// }

registerSessionExpiryHandler(router);
installScrollbarVisibility();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found.');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* One provider for every info-bulle of the design system (shared open delays),
          and the toasts of the design system. */}
      <TooltipProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
